import { Box } from '@domain-group/suit-theme'

import { CampaignComparableModel } from '@models/types'

import CampaignComparableListItem from '../../CampaignComparableListItem'

type ListViewProps = {
  campaignComparables: CampaignComparableModel[],
}

const ListView = (props: ListViewProps) => {
  const { campaignComparables } = props

  return (
    <Box flexDirection="column">
      {campaignComparables.map(campaignComparable => (
        <CampaignComparableListItem
          campaignComparable={campaignComparable}
          key={campaignComparable.id}
        />
      ))}
    </Box>
  )
}

export default ListView
